"use client";
import { WinnersContextProvider } from "@/contexts/winners";
import CategoriesContent from "./main";
import MainContent from "./main/main-content";
import { Categories } from "@/types/winners";

type Props = {
  categories: Categories[];
};

export default function WinnersContent({ categories }: Props) {
  return (
    <WinnersContextProvider categories={categories}>
      <div className="mb-10 mt-16 flex sm:mb-14 sm:mt-40">
        <CategoriesContent />
      </div>
      <MainContent />
    </WinnersContextProvider>
  );
}
